import { render, staticRenderFns } from "./DropShipUpload.vue?vue&type=template&id=4c89d046&"
import script from "./DropShipUpload.vue?vue&type=script&lang=js&"
export * from "./DropShipUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports